import type { Challan, Intent } from '../data/challans';

export function getAssistantResponse(
  intent: Intent,
  vehicle: string,
  challans: Challan[]
): string {
  const unpaid = challans.filter((c) => c.status === 'Unpaid');
  const totalDue = unpaid.reduce((sum, c) => sum + c.amount, 0);
  const paid = challans.filter((c) => c.status === 'Paid');
  const earliestDue = [...unpaid].sort(
    (a, b) => new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime()
  )[0];

  switch (intent) {
    case 'amount':
      return `You have ${unpaid.length} unpaid challan${unpaid.length === 1 ? '' : 's'} for **${vehicle}**. Total amount due: **₹${totalDue.toLocaleString('en-IN')}**.`;
    case 'status':
      return `Out of ${challans.length} challan${challans.length === 1 ? '' : 's'}, ${unpaid.length} ${unpaid.length === 1 ? 'is' : 'are'} unpaid and ${paid.length} ${paid.length === 1 ? 'is' : 'are'} paid.`;
    case 'payment':
      return `Tap a challan card, then tap **Pay Now**. You can pay via UPI, card, or net banking.`;
    case 'dueDate':
      return earliestDue
        ? `Your earliest due date is **${earliestDue.dueDate}** for challan **${earliestDue.id}**.`
        : `No unpaid challans due.`;
    default:
      return `I can help with challan amounts, payment status, payment steps, and due dates. Tap a quick reply or type your question.`;
  }
}
